var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewIconFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.0357 3.80078H6.95261C5.70351 3.80176 4.57236 4.53886 4.06698 5.68115C3.56159 6.82343 3.77695 8.15626 4.61636 9.08126L15.0535 20.5598V31.3854C15.0537 31.8172 15.3008 32.2109 15.6896 32.3987C15.8419 32.4738 16.0096 32.5123 16.1794 32.5113C16.4353 32.5111 16.6835 32.4237 16.8831 32.2636L18.9941 30.5747L22.5126 27.76C22.7793 27.5465 22.9346 27.2234 22.9348 26.8818V20.5598L33.3719 9.08126C34.2113 8.15626 34.4267 6.82343 33.9213 5.68115C33.4159 4.53886 32.2848 3.80176 31.0357 3.80078Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewIconFilter);
export default __webpack_public_path__ + "static/media/new-icon-filter.2b088f7d154a5c381f674271d19ebaf7.svg";
export { ForwardRef as ReactComponent };